import { gql } from "apollo-boost";

const GET_PRODUCT_LIST = gql`
  query getProductList($input: GetListInputV1) {
    getProductList(input: $input) {
      status
      error
      data {
        ... on SellerProductListData {
          count
          productList {
            _id
            approved
            status
            title
            vendor
            vendorId
            images {
              imageUrl
            }
            productId
            createdAt
            published
            variants {
              barcode
              comparePrice
              customRule
              customLabel
              customCharge
              vendorDiscount {
                price
                type
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_PRODUCT_LIST;
